export const printerDriver = [
    {
        label: 'PRINTERS.DETAIL.EPOS',
        value: 'epos'
    },
    {
        label: 'PRINTERS.DETAIL.ESC_POS',
        value: 'escpos'
    }
]

export const LINE_SPACING = [
    {
        label: 'PRINTERS.DETAIL.NONE',
        value: 0
    },
    {
        label: 'PRINTERS.DETAIL.ONE_ROW',
        value: 80
    }
]

export const ITEM_SPACINGS = [
    {
        label: 'PRINTERS.DETAIL.NONE',
        value: 0
    }, 
    {
        label: 'PRINTERS.DETAIL.ONE_ROW',
        value: 1
    }
]

export const ITEMS_ALIGNS = [
    {
        label: 'PRINTERS.DETAIL.LEFT',
        value: 'left'
    }, 
    {
        label: 'PRINTERS.DETAIL.CENTER',
        value: 'center'
    }, 
    {
        label: 'PRINTERS.DETAIL.RIGHT',
        value: 'right'
    }
]

export const HEADER_SIZE = [
    {
        label: 'PRINTERS.DETAIL.DISABLED',
        value: -1
    }, {
        label: 'PRINTERS.DETAIL.SMALL',
        value: 0
    }, {
        label: 'PRINTERS.DETAIL.MEDIUM',
        value: 16
    }, {
        label: 'PRINTERS.DETAIL.BIG',
        value: 17
    }
]

export const FONT_SIZE = [
    {
        label: 'PRINTERS.DETAIL.SMALL',
        value: 0
    }, {
        label: 'PRINTERS.DETAIL.MEDIUM',
        value: 16
    }, {
        label: 'PRINTERS.DETAIL.BIG',
        value: 17
    }
]

export const ITEMS_GROUP_BY = [
    {
        label: 'PRINTERS.DETAIL.EXIT',
        value: 'exit'
    }, {
        label: 'PRINTERS.DETAIL.CATEGORY',
        value: 'category_id'
    },{
        label: 'PRINTERS.DETAIL.EXIT_AND_CATEGORY',
        value: 'exit_and_category'
    }

]